/* eslint-disable no-console */

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
    register(`${process.env.BASE_URL}service-worker.js`, {
        // Bypass HTTP cache when checking for a new worker after a deploy.
        registrationOptions: {
            updateViaCache: "none",
        },
        ready() {
            console.log(
                "App is being served from cache by a service worker.\n" +
                    "For more details, visit https://goo.gl/AFskqB",
            );
        },
        registered(registration) {
            console.log("Service worker has been registered.");
            registration.update();
            setInterval(() => {
                registration.update();
            }, 60 * 60 * 1000);
        },
        cached() {
            console.log("Content has been cached for offline use.");
        },
        updatefound() {
            console.log("New content is downloading.");
        },
        updated() {
            console.log("New content is available.");
        },
        offline() {
            console.log("No internet connection found. App is running in offline mode.");
        },
        error(error) {
            console.error("Error during service worker registration:", error);
        },
    });
}
